import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { EditCustomPDFReportConfirmationDetails } from 'AgentApp/ts/interfaces/agent-event';

@Component({
    selector: 'ycn-edit-custom-pdf-report-confirmation-details',
    imports: [],
    templateUrl: './edit-custom-pdf-report-confirmation-details.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditCustomPDFReportConfirmationDetailsComponent {
    protected readonly details = input.required<EditCustomPDFReportConfirmationDetails>();

    protected humanizeAttribute(key: string): string {
        const spaced = key.replace(/_/g, ' ');
        return spaced.charAt(0).toUpperCase() + spaced.slice(1);
    }
}
